import { useRef } from "react";
import {
	AlertDialog,
	AlertDialogBody,
	AlertDialogCloseButton,
	AlertDialogContent,
	AlertDialogFooter,
	AlertDialogHeader,
	AlertDialogOverlay,
	Button,
	Text,
} from "@chakra-ui/react";

interface AlertParams {
	isOpen: boolean;
	onRequestClose: (close: boolean) => void;
	textAlert: {
		header: string;
		body: string;
		is_toast: boolean;
	};
	execFunction: (is_toast: boolean) => void;
};

const Alert: React.FC<AlertParams> = ({
	isOpen,
	onRequestClose,
	textAlert,
	execFunction,
}) => {
	const cancelRef = useRef<any>(null);

	return (
		<AlertDialog
			motionPreset='slideInRight'
			size="sm"
			leastDestructiveRef={cancelRef}
			onClose={() => onRequestClose(false)}
			isOpen={isOpen}
			isCentered
		>
			<AlertDialogOverlay />

			<AlertDialogContent mx={["2", ""]}>
				<AlertDialogHeader>{textAlert.header}</AlertDialogHeader>

				<AlertDialogCloseButton />

				<AlertDialogBody fontWeight={500}>
					{textAlert.body}
				</AlertDialogBody>

				<AlertDialogFooter>
					<Button
						colorScheme="blackAlpha"
						ref={cancelRef}
						onClick={() => onRequestClose(false)}
					>
						Não
					</Button>

					<Button
						colorScheme="red"
						ml={3}
						onClick={() => execFunction(textAlert.is_toast)}
					>
						Sim
					</Button>
				</AlertDialogFooter>
			</AlertDialogContent>
		</AlertDialog>
	)
}

export default Alert;